module.exports = __webpack_public_path__ + "media/images/athletes/83-41a2ac713f79e8b5c40d3658eaf8e5b4.png";